import KeenSlider from 'keen-slider';
import 'keen-slider/keen-slider.min.css'
import $ from 'jquery'; 

function recipeSlick(){
   // console.log("recipe running");
    fixHeight();
    $('document').ready(function () { 
        //console.log('ran recipeSlick');
    });
    $(window).resize(function(){
        fixHeight();
    }).resize();

    // Select the target node
    var slider = initSlider();
      
    const targetNode = $('.RecipeGallery .keen-slider')[0];

    // Create a new instance of MutationObserver
    const observer = new MutationObserver((mutationsList, observer) => {
    // Handle mutations here
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            slider.destroy();
            initSlider();
            fixHeight();
        }
    }
    });

    // Configure and start the observer
    const observerConfig = { childList: true, subtree: true };
    observer.observe(targetNode, observerConfig);

    function initSlider(){
        const slider = new KeenSlider('.RecipeGallery .keen-slider', {
            loop:true,
            mode:'snap',
            slides: {
                perView: 1,
                spacing: 15,
                origin: 'center',
            },
            breakpoints: {
              "(min-width: 400px)": {
                slides: { perView: 1, spacing: 5 },
              },
              "(min-width: 700px)": {
                slides: { perView: 2, spacing: 15 },
              },
              "(min-width: 1000px)": {
                slides: { perView: 3, spacing: 15 },
              },
              "(min-width: 1200px)": {
                slides: { perView: 4, spacing: 20 },
              },
            }
          },[
            slider => {
                slider.on('created',() =>{
                    const container = slider.container;
                    const prevArrow = container.nextElementSibling;
                    const nextArrow = prevArrow.nextElementSibling;
    
                    prevArrow.addEventListener('click', () => slider.prev());
                    nextArrow.addEventListener('click', () => slider.next());
                })
            }
          ]);
       // console.log(slider.slides);
        //
        switch (slider.slides.length){
            case 1:
                slider.slides[0].style.maxWidth = '500px';
                slider.slides[0].style.margin = 'auto';
                $('.RecipeGallery .arrow').css({'display' : 'none'});
                break;
            case 2:
                //console.log('case 2');
                $('.RecipeGallery .arrow').css({});
                slider.update({
                    slides:{
                        perView: 1,
                    },
                    breakpoints: {
                        "(min-width: 400px)": {
                          slides: { perView: 1, spacing: 5 },
                        },
                        "(min-width: 700px)": {
                          slides: { perView: 1, spacing: 15 },
                        },
                        "(min-width: 1000px)": {
                          slides: { perView: slider.slides.length, spacing: 15 },
                        },
                        "(min-width: 1200px)": {
                          slides: { perView: slider.slides.length, spacing: 20 },
                        },
                    }
                });
                if ($(window).width() > 700) {
                    $('.RecipeGallery .arrow').css({'display' : 'none'});
                } else{
                    $('.RecipeGallery .arrow').css({});
                }
            case 3:
                //console.log('case 3');
                slider.update({
                    slides:{
                        perView: 1,
                    },
                    breakpoints: {
                        "(min-width: 400px)": {
                          slides: { perView: 1, spacing: 5 },
                        },
                        "(min-width: 700px)": {
                          slides: { perView: 2, spacing: 15 },
                        },
                        "(min-width: 1000px)": {
                          slides: { perView: 2, spacing: 15 },
                        },
                        "(min-width: 1200px)": {
                          slides: { perView: slider.slides.length, spacing: 20 },
                        },
                    }
                });
                if ($(window).width() > 1200) {
                    $('.RecipeGallery .arrow').css({'display' : 'none'});
                } else {
                    $('.RecipeGallery .arrow').css({});
                }
                break;
            default:
                break;
        }
        //console.log(slider);
        // if(slider.slides.length > 1){
        //    // console.log(slider);
        //     $('.RecipeGallery button.arrow').css({});
        // } else {
        //     slider.slides[0].style.maxWidth = '500px';
        //     slider.slides[0].style.margin = 'auto';
        //     $('.RecipeGallery button.arrow').css({'display' : 'none'});
        // }
        return slider;
    }

    function fixHeight(){
        //console.log('recipeSlider fixHeight');
        // let totalHeight = $('.RecipeGallery figure.leaf').outerHeight();
        // let tallestElement = 0;
        // $.each($('.RecipeGallery figure.leaf figcaption'), function () { 
        //     tallestElement = $(this).outerHeight() > tallestElement ? $(this).outerHeight() : tallestElement;
        //    // console.log(tallestElement);
        // });
        // $.each($('.RecipeGallery figure.leaf figcaption'), function (){
        //     $(this).css('height',tallestElement);
        // });
        // $('.RecipeGallery figure.leaf img').css('height',totalHeight-tallestElement);

         //Set figcaption
         
         
         //Set image height
         /// < for smallest
         
        let tallestElement = 500;
        $.each($('.RecipeGallery figure img'), function () { 
            tallestElement = $(this).attr('height') < tallestElement ? $(this).attr('height')  : tallestElement;
        });
        // console.log(tallestElement);
        $.each($('.RecipeGallery figure img'), function (){
            $(this).css('height',tallestElement);
        });

        setTimeout(() => {
            tallestElement = 0;
            //console.log('.top');
            $.each($('.RecipeGallery figure figcaption .top'), function () { 
                tallestElement = $(this).outerHeight() > tallestElement ? $(this).outerHeight() : tallestElement;
                //console.log($(this).text());
                //console.log($(this).outerHeight());
            });
            // //console.log(tallestElement);
            $.each($('.RecipeGallery figure figcaption .top'), function (){
                $(this).css('height',tallestElement);
            });
    
            //Set footer caption
    
            tallestElement = 0;
            //console.log('.bottom');
            $.each($('.RecipeGallery figure figcaption .bottom'), function () { 
                tallestElement = $(this).outerHeight() > tallestElement ? $(this).outerHeight() : tallestElement;
            });
            // //console.log(tallestElement);
            $.each($('.RecipeGallery figure figcaption .bottom'), function (){
                $(this).css('height',tallestElement);
            });
        },250);
            

        //Set figure itself
            
        tallestElement = 0;
        setTimeout(() => {
            // console.log('full figure');
            // let tallestElement = 0;
            // $.each($('.RecipeGallery figure:has(.extra-footer)'), function () { 
            //     tallestElement = $(this).outerHeight() > tallestElement ? $(this).outerHeight() : tallestElement;
            //     console.log(tallestElement);
            // });
            // console.log(tallestElement);
            // $.each($('.RecipeGallery figure:has(.extra-footer)'), function (){
            //     $(this).css('height',tallestElement);
            // });

            $.each($('.RecipeGallery .keen-slider'), function(){
                const arrows = $(this).siblings('.arrow');
                const top = $(this).siblings('h2').height() + ($(this).height() / 2);
               // console.log( $(this).siblings('h2').height());
               // console.log( $(this).height() / 2);
                arrows.css({
                    'top':top
                });
            });;
        }, 300);
    }

    return (null)
}

 export default recipeSlick